/**
 * Utility function for combining class names, filtering out null, undefined, and empty values
 * @param classNames Array of potential class name values
 * @returns Trimmed string of combined class names
 */
export function combineClassNames(...classNames: (string | null | undefined)[]): string {
	return classNames
		.filter((className): className is string => typeof className === 'string' && className.trim().length > 0)
		.join(' ')
		.trim();
}

export default {
	combineClassNames,
};
